import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../core/api.service';
import { ApiResponse } from '../../models/api-response.model';
import { TaskFormValue } from '../../models/task-dialog.model';
import { HandoverTaskFormValue, HighAlertTaskFormValue, ShiftLogTaskFormValue } from '../../components/dialogs/task-dialogs/task.dialog.model';

export abstract class LogApiService<Log, LogPost, LogDto> {
  constructor(
    protected apiService: ApiService,
    protected base: string
  ) {}

  protected abstract mapEntity(dto: LogDto): Log;

  public abstract createPayload(formValue: ShiftLogTaskFormValue | HandoverTaskFormValue | HighAlertTaskFormValue, userId: string): LogPost;

  // GET list
  list(page = 1, perPage = 100): Observable<Log[]> {
    const url = `${this.base}?page=${page}&per_page=${perPage}`;
    return this.apiService.get<ApiResponse<LogDto[]>>(url).pipe(
      map((response) => response.data),
      map((dtos) => dtos.map((dto: LogDto) => this.mapEntity(dto)))
    );
  }

  // GET object
  getById(id: string): Observable<Log> {
    return this.apiService.get<ApiResponse<LogDto>>(`${this.base}/${id}`).pipe(
      map((response) => response.data),
      map((dto) => this.mapEntity(dto))
    );
  }

  // POST
  create(log: LogPost): Observable<any> {
    return this.apiService.post<any>(this.base, log);
  }

  // PUT
  update(id: string, log: Partial<LogPost>): Observable<any> {
    return this.apiService.put<any>(`${this.base}/${id}`, log);
  }

  // DELETE
  remove(id: string): Observable<void> {
    return this.apiService.delete<void>(`${this.base}/${id}`);
  }

  removeMultiple(selectedIds: Set<string>): Observable<unknown> {
    const ids = Array.from(selectedIds);
    if (ids.length === 0) {
      return of([]);
    }
    const requests = ids.map((id) => this.remove(id)); // remove(id) returns Observable<...>
    return forkJoin(requests);
  }
}
